export const Colors = {
    primary: '#80A6EA',
    secondary: '#5B69B7',
}